import styled from 'styled-components'
import { useEffect, useContext } from "react";
import { TranslationContext } from '../context/TranslationContext'

function Checkout() {
    const { translations } = useContext(TranslationContext)

    useEffect(() => {
        // window.location.href = 'https://reservations.bohemehouse.lt/'
    }, [])
    return (
        <Wrapper>
            <div>{ translations.checkout }</div>
        </Wrapper>
    );
}

const Wrapper = styled.div`
    flex: 1;
    flex-direction: column;
    display: flex;
    align-items: center;
    justify-content: center;
`

export default Checkout;
